// import NuDate from "../../../../Components/Utils/NuDate";

// function NewProjectStatus({data}) {
//   return (
//     <div className=" w-full h-[65vh] 2xl:h-[45vh] p-2 rounded-lg bg-white" style={{ border: "1px solid #E9E8EC" }}>
//     <p className=" text-mainColor-400  line-clamp-2 font-semibold text-[14px] lg:text-[14px] xl:text-[14px] ">Project Status</p>
//     <div className=" w-full overflow-y-scroll h-[calc(45vh-40px)]">
//             <table className="overflow-hidden text-center  text-xs border-collapse w-full overflow-y-scroll">
//               <thead className="border-b   bg-white rounded-md overflow-hidden font-medium  text-xs">
//                 <tr
//                   className=""
//                   style={{
//                     borderTop: "1px solid #E9E8EC ",
//                     borderBottom: "1px solid #E9E8EC ",
//                   }}
//                 >
//                   <th
//                     scope="col"
//                     className="sticky py-2 w-[30%] font-semibold text-[#6C6580] text-xs text-start pl-2 "
//                   >
//                     Major Activities
//                   </th>
//                   <th
//                     scope="col"
//                     className="sticky py-2 w-[12%] font-semibold text-[#6C6580] text-xs text-start pl-2 "
//                   >
//                     Status
//                   </th>
//                   <th
//                     scope="col"
//                     className="sticky py-2 w-[12%] text-left font-semibold text-[#6C6580] text-xs"
//                   >
//                     Start Date
//                   </th>
//                   <th
//                     scope="col"
//                     className="sticky py-2 w-[12%] text-left font-semibold text-[#6C6580] text-xs"
//                   >
//                     End Date
//                   </th>
//                   <th
//                     scope="col"
//                     className="sticky py-2 w-[12%] text-left font-semibold text-[#6C6580] text-xs"
//                   >
//                     Remaining
//                   </th>
//                   <th
//                     scope="col"
//                     className="sticky py-2 w-[12%] text-left font-semibold text-[#6C6580] text-xs"
//                   >
//                     Plan
//                   </th>
//                   <th
//                     scope="col"
//                     className="sticky py-2 w-[12%] text-left font-semibold text-[#6C6580] text-xs"
//                   >
//                     Actual
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className=" px-2 ">
//                 {data &&
//                   data.map((Item, Index) => {
//                     console.log("ccc",Item?.taskStatus);
//                     return (
//                       <tr
//                         key={Index}
//                         className="p-3 border-b transition duration-300 ease-in-out hover:bg-neutral-100  h-10"
//                         style={{ borderBottom: "1px solid #E9E8EC " }}
//                       >
//                          <td className="pl-2 text-left text-[#4F4768] l w-[30%] h-full  text-xs">
//                           <div className=" w-full h-full items-center ine-clamp-2">
//                           {Item?.projName || "-"}
//                           </div>
//                         </td>
//                         <td className="pl-2 text-left text-[#4F4768] l w-[30%] h-full  text-xs">
//                           <div className=" w-full h-full items-center ine-clamp-2">
//                           {Item?.taskStatus || "-"}
//                           </div>
//                         </td>
//                         <td className="pl-2 text-left text-[#4F4768] l w-[20%] h-full  text-xs">
//                           <div className=" w-full h-full items-center ine-clamp-2">
//                           {Item?.startDate && <NuDate value={Item?.startDate} format="DD-MMM-YYYY" /> || "-"}
//                           </div>
//                         </td>
//                         <td className="pl-2 text-left text-[#4F4768] l w-[20%] h-full  text-xs">
//                           <div className=" w-full h-full items-center ine-clamp-2">
//                           {Item?.endDate && <NuDate value={Item?.endDate} format="DD-MMM-YYYY" /> || "-"}
//                           </div>
//                         </td>
//                         <td className="pl-2 text-left text-[#4F4768] l w-[30%] h-full  text-xs">
//                           <div className=" w-full h-full items-center ine-clamp-2 text-center">
//                           {Item?.taskCompletion || "0"}%
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//               </tbody>
//             </table>
//           </div>
//   </div>
//   )
// }

// export default NewProjectStatus


import React from "react";

const projectData = [
  {
    name: "Nutrack",
    status: "In-Progress",
    statusColor: "text-blue-500",
    progress: "+2.5%",
    progressColor: "text-green-500",
    startDate: "16-Jan-23",
    endDate: "31-Dec-23",
    remaining: "+78 days",
    plan: "24.75%",
    actual: "27.25%",
  },
  {
    name: "Louis Vuitton",
    status: "In-Progress",
    statusColor: "text-blue-500",
    progress: "-4.21%",
    progressColor: "text-red-500",
    startDate: "16-Jan-23",
    endDate: "31-Dec-23",
    remaining: "",
    plan: "",
    actual: "",
  },
  {
    name: "Hamilton Mall",
    status: "On Hold",
    statusColor: "text-orange-500",
    progress: "",
    progressColor: "",
    startDate: "16-Jan-23",
    endDate: "31-Dec-23",
    remaining: "",
    plan: "",
    actual: "",
  },
];

const NewProjectStatus = () => {
  return (
    <div className="bg-white p-4 rounded-lg drop-shadow-lg h-[45vh] 2xl:h-[35vh] w-full">
      <h2 className="text-sm font-semibold text-[#4F4768]">Project Status</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b">
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Major Activities</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Status</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Start Date</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">End Date</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Remaining</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Plan</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Actual</th>
            </tr>
          </thead>
          <tbody>
            {projectData.map((project, index) => (
              <tr key={index} className="border-b">
                <td className="p-2 text-xs font-normal  items-center">
                 
                  {project.name}
                  <div className="flex gap-2 items-center">
                  <div className="w-20 h-1 bg-gray-300 rounded-full  relative">
                    <div className="w-3/4 h-1 bg-blue-500 rounded-full"></div>
                  </div>
                  <div>
                  {project.progress && (
                    <span className={` font-normal ${project.progressColor}`}>
                      {project.progress}
                    </span>
                  )}</div>
                  </div>
                </td>
                <td className={`p-2 text-xs font-normal  ${project.statusColor}`}>
                  {project.status}
                </td>
                <td className="p-2 text-xs font-normal">{project.startDate}</td>
                <td className="p-2 text-xs font-normal">{project.endDate}</td>
                <td className="p-2 text-xs font-normal">{project.remaining}</td>
                <td className="p-2 text-xs font-normal">{project.plan}</td>
                <td className="p-2 text-xs font-normal ">
                  
                  {project.actual}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewProjectStatus;